import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EnrollmentDuplicatesService } from 'src/app/services/enrollment-duplicates.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { getErrorMessage } from 'src/app/utils/error-message';
import { PermissionGroups } from 'src/app/utils/PermissionGroups';

/** Dashboard alert audience from the ticket: LRNext-Admin and LRNext-EDI-Contributor. */
export const ENROLLMENT_DUPLICATES_ALERT_GROUPS = [
  PermissionGroups.Admin,
  PermissionGroups.EDIContributor
];

@UntilDestroy()
@Component({
  selector: 'vex-enrollment-duplicates-alert',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './enrollment-duplicates-alert.component.html',
  styleUrls: ['./enrollment-duplicates-alert.component.scss']
})
export class EnrollmentDuplicatesAlertComponent implements OnInit {
  loading = false;
  count = 0;

  constructor(
    private enrollmentDuplicatesService: EnrollmentDuplicatesService,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.loadDuplicates();
  }

  get showCard(): boolean {
    return this.loading || this.count > 0;
  }

  get formattedCount(): string {
    return this.count.toLocaleString('en-US');
  }

  get decisionPhrase(): string {
    return this.count === 1
      ? 'enrollment duplicate requires a decision'
      : 'enrollment duplicates require a decision';
  }

  private loadDuplicates(): void {
    this.loading = true;
    this.enrollmentDuplicatesService
      .getPendingCount()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (result) => {
          this.count = result?.count ?? 0;
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.count = 0;
          this.snackbarService.open(
            getErrorMessage(err, 'Failed to load enrollment duplicates.'),
            'error'
          );
        }
      });
  }
}
